export default __webpack_public_path__ + "static/screenshot3-e6a79a5391dbaed6de7e8496f5ab7e63.jpg";